// Copyright (c) Ensho Health, 2021 to present

import PropTypes from 'prop-types';
import React from 'react';
import { Spinner } from '@blueprintjs/core';
import { BlurContainer } from './BlurLoader.styles.js';

const BlurLoader = (props) => {
  if (props.loading) {
    return (
      <BlurContainer>
        <Spinner />
      </BlurContainer>
    );
  } else {
    return null;
  }
};

BlurLoader.propTypes = {
  loading: PropTypes.bool,
  label: PropTypes.string
};

export default BlurLoader;
